"use strict";

define('evisions/helper/common',['underscore'], function (_) {
  var EVIHelperCommon = _.extend({
    createWithArgs: function createWithArgs(func, args) {
      var ctor = function ctor() {},
        child = null,
        result = null;
      ctor.prototype = func.prototype;
      child = new ctor(), result = func.apply(child, args);
      return Object(result) === result ? result : child;
    },
    inherit: function inherit(child, parent) {
      var __hasProp = {}.hasOwnProperty;
      for (var key in parent) {
        if (__hasProp.call(parent, key)) {
          child[key] = parent[key];
        }
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    loadLayer: function loadLayer(layer, fn, errorFn) {
      if (window.moduleMap && window.moduleMap[layer]) {
        require([window.moduleMap[layer]], function () {
          require([layer], fn);
        });
      } else {
        require([layer], fn, errorFn);
      }
    },
    lowerKeyCase: function lowerKeyCase(object) {
      var ret = {},
        newKey = null;
      _.each(object, function (value, key) {
        if (key) {
          newKey = key[0].toLowerCase() + key.slice(1);
          ret[newKey] = value;
        } else {
          ret[key] = value;
        }
      });
      return ret;
    },
    setPropertyByNamespace: function setPropertyByNamespace(obj, key, value) {
      key = key || '';
      var namespaces = key.split('.'),
        o = obj,
        ns = null,
        i = 0;
      if (namespaces.length < 1) {
        return;
      }
      for (i = 0; i < namespaces.length - 1; ++i) {
        ns = namespaces[i];
        if (o[ns] == null) {
          o[ns] = {};
        }
        o = o[ns];
      }
      ns = namespaces[namespaces.length - 1];
      o[ns] = value;
      return value;
    },
    getPropertyByNamespace: function getPropertyByNamespace(obj, key) {
      key = key || '';
      var namespaces = key.split('.'),
        o = obj,
        ns = null,
        i = 0;
      if (namespaces.length < 1) {
        return null;
      }
      for (i = 0; i < namespaces.length; ++i) {
        ns = namespaces[i];
        if (o == null) {
          return null;
        }
        if (i === namespaces.length - 1) {
          return o[ns];
        }
        o = o[ns];
      }
      return null;
    },
    requireArray: function requireArray(passedArr, fn) {
      var i = 0,
        s = null;
      for (i = 0; i < passedArr.length; ++i) {
        s = passedArr[i];
        if (_.isString(s) && s.slice(0, 2) === '//') {
          passedArr[i] = s.slice(2);
        }
        s = passedArr[i];
        if (_.isString(s) && s.slice(-3) === '.js') {
          passedArr[i] = s.slice(0, -3);
        }
      }
      require(passedArr, fn);
    },
    findObjectByProperty: function findObjectByProperty(obj, traverse, property, value) {
      var _findMatchingObject = function findMatchingObject(d) {
        var found = null,
          children = _.isFunction(d[traverse]) ? d[traverse]() : d[traverse];
        if (d[property] == value) {
          return d;
        }
        for (var i = 0; i < children.length; i++) {
          found = _findMatchingObject(children[i]);
          if (found) {
            break;
          }
        }
        return found;
      };
      return _findMatchingObject(obj);
    },
    objectMatchesFilter: function objectMatchesFilter(obj, filterObjs) {
      filterObjs = filterObjs instanceof Array ? filterObjs : [filterObjs];
      var len = filterObjs.length,
        valid = false;
      for (var i = 0; i < len; i++) {
        var filter = filterObjs[i],
          filterVal = filter.value;
        value = obj[filter.name], type = filter.type;
        switch (type) {
          case 'String':
            filterVal = filterVal.toLowerCase();
            valid = String(value || '').toLowerCase().indexOf(filterVal) > -1;
            break;
          case 'Number':
            valid = parseInt(value) === parseInt(filterVal);
            break;
          default:
            valid = value == filterVal;
            break;
        }
        if (valid) {
          return true;
        }
      }
      return false;
    },
    hasFileReaderSupport: function hasFileReaderSupport() {
      return !!(window.File && window.FileReader && window.FileList && window.Blob);
    }
  });
  return EVIHelperCommon;
});

